// extracted by mini-css-extract-plugin
export default {"select":"languageBlock_select__MnGgw","iso-code":"languageBlock_iso-code__H3AyC","lanugage-icon":"languageBlock_lanugage-icon__tAvZ3","dropdown":"languageBlock_dropdown__Wh-Ob"};